/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect, } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar_16 } from "../../../Routes/ImagePath";
import dayjs from "dayjs";
import ProfileTab from "./ProfileTab";
import { S3ACCESSURL, SERVER_URL } from "../../../databucket.js";
import axios from "axios";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Button } from 'react-bootstrap';
import { useParams } from "react-router-dom";
import ReportingTable from "./ReportingManager";
import WorkHistorys from "./WorkHistory.jsx";
import ClientHistory from "./ClientInformation";
import FamilyInfo from "./familyInformation";
import EditHistory from "./editworkhistory.jsx";
import EducationComponent from "./education";
import PersonalInformationModelPopup from "../../../components/modelpopup/PersonalInformationModelPopup";
import { useRef } from "react";
import { useSelector } from 'react-redux';
import { setLoader } from "../../../Slices/loaderSlice.jsx";
import ConditionMenu from "../../layout/conditionMenu.js";
import { setreupdate } from "../../../Slices/DyanamicRoute.js";
import AttendanceEmployee from "../Employees/AttendenceEmployee.jsx";
import EmployeeLeave from "../Employees/EmployeeLeave.jsx";
import ProfileLeaveSettings from "./ProfileLeaveSettings.jsx";
import { SetAllEmployees } from "../../../Slices/employeeslice.js";
import { updateEmployee } from "../../../Slices/Thunk/employeeThunk.js";
import { fetchAllAttachments, fetchSingleUser } from "../../../Slices/Thunk/employeeThunk.js";
import EmployeeEmailSettings from "./EmployeeEmailSettings.jsx";
import { useRecordLock } from "../../../hooks/useRecordLock";
import RecordLockedModal, { ReleaseRequestBanner } from "../../../components/RecordLockedModal";
const Profile = () => {
  const Navigation = useNavigate();
  const empUpdate = useSelector((state) => state.Route.reupdate)
  const fileInputRef = useRef(null);
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    dispatch(setreupdate(false));
  }, [empUpdate])
  const dispatch = useDispatch();
  const { Empid } = useParams();
  const [activeTab, setActiveTab] = useState(Empid ? "emp_profile" : "work_history");
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const [image, setImage] = useState(null);
  const id = loginUser?.id;
  const ids = Empid ? Empid : id;

  // Session lock — only lock when viewing another employee's profile (Empid present)
  const {
    isReadOnly: lockIsReadOnly,
    lockedBy,
    lockChecked,
    requestAccess,
    releaseRequested,
    releaseRequestFrom,
    dismissReleaseRequest,
    releaseForRequester,
  } = useRecordLock("employees", Empid || null);

  const [viewReadOnly, setViewReadOnly] = useState(false);
  const isReadOnly = Empid ? (lockIsReadOnly && viewReadOnly) : false;
  const userData = useSelector((state) => state.employee.userData);
  const detail = useSelector((state) => state.employee.AllEmployees)
  function getInitials(name) {
    if (!name) return 'N/A';
    const names = name.split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    const firstInitial = names[0].charAt(0).toUpperCase();
    const secondInitial = names[1] ? names[1].charAt(0).toUpperCase() : '';
    return firstInitial + secondInitial;
  }

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchSingleUser({ id: ids }));
      await dispatch(fetchAllAttachments({ ID: ids }));
    };

    if (ids) {
      fetchData();
    }
  }, [ids, dispatch]);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      dispatch(setLoader(true));
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result); // Set preview image
      };
      reader.readAsDataURL(file);
      const formData = new FormData();
      formData.append('files', file);
      try {
        const res = await axios.post(`${SERVER_URL}/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        const savedFile = res.data.files[0];
        const input = { image: savedFile.url }
        let { data } = await dispatch(updateEmployee({ id: ids, input }));
        if (data?.payload) {
          setImage(savedFile.url);
          const updatesEmp = detail?.map((employee) =>
            employee.id === ids
              ? {
                ...employee,
                image: savedFile.url
              }
              : employee
          );

          dispatch(SetAllEmployees(updatesEmp));
        }

        setImage(savedFile.url);
        dispatch(setLoader(false));
      } catch (error) {

      }
    }
  };

  useEffect(() => {


  }, [image, userData?.image])
  const handleDelete = async () => {
    dispatch(setLoader(true))
    let { data } = await updateEmployee({
      variables: {
        id: ids,
        input: {
          image: null,
        },
      },
    });
    if (data?.UpdateEmploye?.status) {
      const updatesEmp = detail?.map((employee) =>
        employee.id === ids
          ? {
            ...employee,
            image: null
          }
          : employee
      );
      setImage(null);
      dispatch(SetAllEmployees(updatesEmp));
      dispatch(setLoader(false))
    }
  }
  const handleGo = () => {
    Navigation(-1)

  }
  return (
    <>
      {/* Record locked by another user */}
      {Empid && lockChecked && lockIsReadOnly && !viewReadOnly && (
        <RecordLockedModal
          visible={true}
          lockedBy={lockedBy}
          onViewReadOnly={() => setViewReadOnly(true)}
          onRequestAccess={requestAccess}
          releaseRequested={releaseRequested}
          onGoBack={() => Navigation(-1)}
        />
      )}

      {/* Banner for lock holder when someone requests access */}
      {Empid && releaseRequestFrom && (
        <ReleaseRequestBanner
          requestFrom={releaseRequestFrom}
          onRelease={() => {
            releaseForRequester();
            Navigation(-1);
          }}
          onDismiss={dismissReleaseRequest}
        />
      )}

      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Read-only banner */}
          {isReadOnly && (
            <div style={{
              background: "#fff7e6", border: "1px solid #ffd591", padding: "8px 16px",
              borderRadius: 6, marginBottom: 8, display: "flex", alignItems: "center", gap: 8,
            }}>
              <span style={{ fontSize: 16 }}>🔒</span>
              <span>
                <strong>Read-Only Mode</strong> — This employee is being edited by{" "}
                <strong>{lockedBy?.userName}</strong>. You can view but not modify.
              </span>
            </div>
          )}
          <Button onClick={handleGo}
            style={{ marginBottom: "5px", width: "5%", padding: "4px 4px" }}
          > Back</Button>
          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">
                    <div className="profile-img-wrap">
                      <div>
                        {image !== null ? (
                          <div style={{ position: "relative", display: "inline-block" }}>
                            <div className="profile-img">
                              <img
                                src={S3ACCESSURL+image}
                                alt="User Image"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "120px",
                                  height: "120px",
                                  borderRadius: "50%",
                                  backgroundColor: "#ccc",
                                  color: "#333",
                                  fontSize: "20px",
                                  position: "relative",
                                  border: "2px solid #ddd",
                                }}
                              />
                              <input
                                type="file"
                                src={S3ACCESSURL + image}
                                accept="image/*"
                                onChange={handleImageChange}
                                style={{ display: "none" }}
                                id="imageUpload"
                                ref={fileInputRef}
                              />
                              <label
                                htmlFor="imageUpload"
                                style={{
                                  position: "absolute",
                                  bottom: "-5px",
                                  right: "10px",
                                  background: "transparent",
                                  color: "#000",
                                  marginLeft: "-15px",
                                  borderRadius: "50%",
                                  cursor: "pointer",
                                  fontSize: "18px",
                                  // Optional border for the edit icon
                                }}
                              >
                                {Empid ? <div className="icon-container">
                                  <Link
                                    onClick={(e) => {
                                      e.preventDefault();
                                      triggerFileInput();
                                    }}
                                    to="#"
                                    className="plus-icon"
                                  >
                                    +
                                  </Link>
                                  <div className="action-icons">

                                    <Link
                                      onClick={(e) => {
                                        e.preventDefault();
                                        triggerFileInput();
                                      }}
                                      to="#"

                                    >
                                      <i className="fa fa-pencil fa-sm" />
                                    </Link>
                                    <Link
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleDelete();
                                      }}
                                      to="#"
                                      className="delete-icon"
                                    >
                                      <i className="fa fa-trash fa-sm" />
                                    </Link>

                                  </div>
                                </div>
                                  : null}
                              </label>
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "120px",
                              height: "120px",
                              borderRadius: "50%",
                              backgroundColor: "#898484",
                              color: "white",
                              fontSize: "20px",
                              position: "relative",
                              border: "2px solid #898484", // Optional border for styling
                            }}
                          >
                            {userData?.firstname ? getInitials(userData.firstname) : "N/A"}
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleImageChange}
                              style={{ display: "none" }}
                              id="imageUpload"
                              ref={fileInputRef}
                            />
                            <label
                              htmlFor="imageUpload"
                              style={{
                                position: "absolute",
                                bottom: "5px",
                                right: "5px",
                                background: "transparent",
                                color: "#000",
                                marginLeft: "-10px",
                                borderRadius: "50%",
                                cursor: "pointer",
                                fontSize: "18px",
                              }}
                            >
                              {Empid && <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  triggerFileInput();
                                }}
                                to="#"
                                className="edit-icon"
                                htmlFor="imageUpload"

                              >
                                <i className="fa fa-pencil" />
                              </Link>}
                            </label>
                          </div>
                        )}
                      </div>

                    </div>
                    <div className="profile-basic">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="profile-info-left">
                            <h3 className="user-name m-t-0 mb-2">
                              {userData.firstname} {userData.lastname}
                            </h3>
                            <ul className="personal-info">
                              <li>
                                <div className="title">Employee ID:</div>
                                <div className="text">
                                  {userData?.EmpID || "N/A"}
                                </div>
                              </li>
                              <li>
                                <div className="title">Designation:</div>
                                <div className="text">
                                  {userData?.designation || "N/A"}
                                </div>
                              </li>
                              <li>
                                <div className="title">Department:</div>
                                <div className="text">
                                  {userData?.department || "N/A"}
                                </div>
                              </li>
                              <li>
                                <div className="title">Proc.Specialization:</div>
                                <div className="text">
                                  {userData?.processSplization || "N/A"}
                                </div>
                              </li>
                              <li>
                                <div className="title">Date of Joining:</div>
                                <div className="text">
                                  {dayjs(userData?.DateOfJoining).format("DD/MM/YYYY") || "N/A"}
                                </div>
                              </li>
                              <li>
                                <div className="title">Role:</div>
                                <div className="text">
                                  {userData?.role || "N/A"}
                                </div>
                              </li>
                              <li>
                                <div className="title">Status:{" "}</div>
                                <div className="text">
                                  {userData?.employeestatus || "N/A"}
                                </div>
                              </li>
                              {userData?.additionalRoles?.length > 0 && (
                                <li>
                                  <div className="title">Additional Roles:</div>
                                  <div className="text">
                                    {userData.additionalRoles.join(", ")}
                                  </div>
                                </li>
                              )}
                              <li>
                                <div className="title">Phone:{" "}</div>
                                <div className="text">
                                  {userData?.mobile || "N/A"}
                                </div>
                              </li>
                              <li>
                                <div className="title">Company Email:{" "}</div>
                                <div className="text">
                                  <Link to="">{userData?.email || "N/A"}</Link>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-md-7">
                          <ul className="personal-info">
                            <li>
                              <div className="title">Alternate Phone:</div>
                              <div className="text">
                                {userData?.alternativeNumber || "N/A"}
                              </div>
                            </li>
                            <li>
                              <div className="title">Birthday:</div>
                              <div className="text">
                                {userData?.dob ? dayjs(userData.dob).format('DD/MM/YYYY') : "N/A"}
                              </div>
                            </li>
                            <li>
                              <div className="title">Personal Email:{" "}</div>
                              <div className="text">
                                <Link to="">{userData?.personalEmail || "N/A"}</Link>
                              </div>
                            </li>
                            <li>
                              <div className="title">Current Address:</div>
                              <div className="text">
                                {userData?.currentAddress || "N/A"}
                              </div>
                            </li>
                            <li>
                              <div className="title">Permanent Address:</div>
                              <div className="text">
                                {userData?.permanentAddress || "N/A"}
                              </div>
                            </li>
                            <li>
                              <div className="title">Gender:</div>
                              <div className="text">
                                {userData?.gender || "N/A"}
                              </div>
                            </li>
                            <li>
                              <div className="title">Marital Status:</div>
                              <div className="text">

                                {userData?.maritalStatus || "N/A"}

                              </div>
                            </li>
                            <li>
                              <div className="title">Blood Group:</div>
                              <div className="text">
                                {userData?.bloodGroup || "N/A"}
                              </div>
                            </li>
                            <li>
                              <div className="title">Reports to:</div>
                              <div className="text">
                                <div className="avatar-box">
                                  <div className="avatar avatar-xs">
                                    <img src={Avatar_16} alt="User Image" />
                                  </div>
                                </div>
                                <Link to="">
                                  {userData?.reportingTo || "N/A"}
                                </Link>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    {Empid && !isReadOnly ? <div className="pro-edit">
                      <Link
                        data-bs-target="#profile_info"
                        data-bs-toggle="modal"
                        className="edit-icon"
                        to="#"
                      >
                        <i className="fa-solid fa-pencil"></i>
                      </Link>
                    </div> : null}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card tab-box">
            <div className="row user-tabs">
              <div className="row g-0 p-0 m-0">
                {/* <div className="col-lg-14 col-md-14 col-sm-14 line-tabs"> */}
                <ul className="nav nav-tabs nav-tabs-bottom">
                  <li className="nav-item">
                    {Empid ? <Link
                      to="#emp_profile"
                      data-bs-toggle="tab"
                      className={`nav-link ${activeTab === "emp_profile" ? "active" : ""}`}
                      onClick={() => setActiveTab("emp_profile")}
                    >
                      Documents
                    </Link> : ""}
                  </li>
                  <li className="nav-item">
                    <Link
                      to="#work_history"
                      data-bs-toggle="tab"
                      className={`nav-link ${activeTab === "work_history" ? "active" : ""}`}
                      onClick={() => setActiveTab("work_history")}
                    >
                      Work
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="#client_history"
                      data-bs-toggle="tab"
                      className={`nav-link ${activeTab === "client_history" ? "active" : ""}`}
                      onClick={() => setActiveTab("client_history")}
                    >
                      Client
                    </Link>
                  </li>
                  <li className="nav-item">
                    {Empid ? <Link
                      to="#Reporting_data"
                      data-bs-toggle="tab"
                      className={`nav-link ${activeTab === "Reporting_data" ? "active" : ""}`}
                      onClick={() => setActiveTab("Reporting_data")}
                    >
                      Teams
                    </Link> : null}
                  </li>
                  <li className="nav-item">
                    <Link
                      to="#education_data"
                      data-bs-toggle="tab"
                      className={`nav-link ${activeTab === "education_data" ? "active" : ""}`}
                      onClick={() => setActiveTab("education_data")}
                    >
                      Education
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      to="#family_info"
                      data-bs-toggle="tab"
                      className={`nav-link ${activeTab === "family_info" ? "active" : ""}`}
                      onClick={() => setActiveTab("family_info")}
                    >
                      Family Information
                    </Link>
                  </li>
                  <li className="nav-item">
                    {Empid ? <Link
                      to="#update_workHistory"
                      data-bs-toggle="tab"
                      className={`nav-link ${activeTab === "update_workHistory" ? "active" : ""}`}
                      onClick={() => setActiveTab("update_workHistory")}
                    >
                      Update WorkHistory
                    </Link> : null}
                  </li>

                  {/* <li className="nav-item">
                    {Empid ? <Link
                      to="#routes"
                      data-bs-toggle="tab"
                      className={`nav-link ${activeTab === "routes" ? "active" : ""}`}
                      onClick={() => setActiveTab("routes")}
                    >
                      Route Access
                    </Link> : null}
                  </li> */}
                  <li className="nav-item">
                    {Empid ? <Link
                      to="#profile_leave_settings"
                      data-bs-toggle="tab"
                      className={`nav-link ${activeTab === "profile_leave_settings" ? "active" : ""}`}
                      onClick={() => setActiveTab("profile_leave_settings")}
                    >
                      Leave Settings
                    </Link> : null}
                  </li>
                  <li className="nav-item">
                    {Empid ? <Link
                      to="#email_settings"
                      data-bs-toggle="tab"
                      className={`nav-link ${activeTab === "email_settings" ? "active" : ""}`}
                      onClick={() => setActiveTab("email_settings")}
                    >
                      Email Settings
                    </Link> : null}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Tab Contents */}
          <div className="tab-content" style={isReadOnly ? { pointerEvents: "none", opacity: 0.7 } : {}}>
            {activeTab === "emp_profile" && <ProfileTab />}
            {activeTab === "Reporting_data" && <ReportingTable />}
            {activeTab === "work_history" && <WorkHistorys />}
            {activeTab === "client_history" && <ClientHistory />}
            {activeTab === "family_info" && <FamilyInfo />}
            {activeTab === "education_data" && <EducationComponent />}
            {activeTab === "update_workHistory" && <EditHistory />}
            {activeTab === "routes" && <ConditionMenu />}
            {activeTab === "Attendence" && <AttendanceEmployee />}
            {activeTab === "Leaves_Tab" && <EmployeeLeave />}
            {activeTab === "profile_leave_settings" && <ProfileLeaveSettings />}
            {activeTab === "email_settings" && <EmployeeEmailSettings />}

          </div>
          <style >
            {`
         .icon-container {
  position: relative;
  display: inline-block;
}

.plus-icon {
  font-size: 20px;
  cursor: pointer;
  
}

.action-icons {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  gap: 5px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.icon-container:hover .action-icons {
  opacity: 1;
}

        `}
          </style>
        </div>
        {!isReadOnly && <PersonalInformationModelPopup />}
      </div>
    </>
  );
};
export default Profile;
